import React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { useJobTitlesQuery } from '../../queries/job-titles'
import JobTitlesList from '../../components/job-titles/list'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { Box, Element, Form, Icon, Message } from 'react-bulma-components'
import JobTitleExplanation from '../../components/job-titles/job-title-explanation'
import { AddResourceIcon, WarningIcon } from '../../components/icons'

/**
 * Component for managing employer job titles
 */
const JobTitlesSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const [showInactive, setShowInactive] = React.useState(false)
  const query: { isInactive?: boolean[] | boolean } = {}
  if (showInactive) {
    query.isInactive = true
  }
  const { data: jobTitles } = useJobTitlesQuery(query, {
    enabled: Boolean(employer),
  })
  const navigate = useNavigate()

  return (
    <>
      <SidebarContentTitle
        title="Métiers"
        onButtonClick={() => navigate('/settings/job-titles/new')}
        addButtonLabel="Nouveau Métier"
        ButtonIcon={AddResourceIcon}
        help={<JobTitleExplanation textColor={'white'} />}
      />
      <Box>
        {showInactive && (
          <Message color="info" className="mb-4">
            <Message.Body>
              <Icon.Text>
                <Icon>
                  <WarningIcon />
                </Icon>
                Vous affichez uniquement les métiers inactifs.
                <br /> Ces métiers ne sont plus utilisés dans les missions et les demandes. Vous
                pouvez les réactiver en les modifiant.
              </Icon.Text>
            </Message.Body>
          </Message>
        )}
        <JobTitlesList data={jobTitles || []} itemPath={`/settings/job-titles/`} />
        <Element textAlign={'right'}>
          <Form.Field>
            <Form.Control>
              <Form.Checkbox
                checked={showInactive}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setShowInactive(e.target.checked)
                }
                data-test="show-inactive-job-titles-checkbox"
              >
                Afficher les métiers inactifs
              </Form.Checkbox>
            </Form.Control>
          </Form.Field>
        </Element>
      </Box>
    </>
  )
}

export default JobTitlesSettings
